import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';
import { AuthService } from '../services/auth-service';

export const isAdminUser = (roles: string[] | null | undefined): boolean =>
  roles?.includes('admin') ?? false;

/** Access granted only to users with the global `admin` role. */
export const adminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const me = await firstValueFrom(
    toObservable(auth.me).pipe(
      filter((user) => user !== null),
      take(1),
    ),
  );

  if (isAdminUser(me?.roles)) {
    return true;
  }
  return router.createUrlTree(['/', 'settings', 'account']);
};
